import * as React from 'react';
import { SVGProps } from 'react';

const SpinnerIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path d="M8 10.498V12M6.23 9.769l-1.058 1.058M5.502 8H4M5.172 5.173 6.23 6.23M8 5.333V4M10.121 5.88l.707-.707M11.999 8h-.667M10.825 10.827l-.235-.235M8 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SpinnerIcon;
